import React, { useState } from "react";
import SectionTitle from "../SectionTitle";
import { db, collection, addDoc } from "../../firebase"; // Ajusta la ruta si es necesario
import ClipLoader from 'react-spinners/ClipLoader';

import { toast } from "react-toastify";

const HairSection = (props) => {

  const [isLoading, setIsLoading] = useState(false);  // Estado para el loader

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    comments: "",
    seats: 1,
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      // Guardar los datos en Firebase Firestore
      await addDoc(collection(db, "HAIR"), {
        name: formData.name || "",
        phone: formData.phone || "",
        comments: formData.comments || "",
        seats: formData.seats || null,
        timestamp: new Date(), // Fecha de envío
      });

      // Desplazarse al elemento con id "campo-nombre"
      const elemento = document.getElementById("hair");
      if (elemento) {
        const posicion = elemento.getBoundingClientRect().top + window.scrollY; // Calcula la posición en la página
        window.scrollTo({
          top: posicion - "0", // Aplica el offset restándolo
          behavior: "smooth", // Desplazamiento suave
        });
      }
      setFormSubmitted(true);
    } catch (error) {
      toast.error('Ha habido un error en el envío', {
        position: "top-center", // Posición central superior
        autoClose: 3000, // Tiempo de duración (en milisegundos)
        hideProgressBar: true, // Mostrar barra de progreso
        closeOnClick: true, // Cierre al hacer clic
        pauseOnHover: true, // Pausa al pasar el cursor
        draggable: true, // Permitir arrastrar el toast
        progress: undefined, // Barra de progreso predeterminada
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className={`section-padding`} id="hair">
      {/* Mostrar el loader mientras isLoading sea verdadero */}
      {isLoading && (
        <div className="loader-overlay">
          <ClipLoader color="#fff" loading={isLoading} size={50} />
        </div>
      )}
      <div className="wpo-cta-section wpo-hair-section">
        <div className="conatiner-fluid">
          <div className="wpo-cta-item">
            <h2>Reserva de Peluquería</h2>
            <p className="p-0 m-0" style={{ color: 'white' }}>(Si prefieres peinarte por tu cuenta, desliza para abajo y sigue descubriendo 😉)</p>
          </div>
        </div>
      </div>
      <div className="container">
        {formSubmitted ? (<div style={{ textAlign: "center", marginTop: "50px" }}>
          <h2>Tu reserva ha sido enviada con exito. 💇‍♀️✨</h2>
        </div>) :

          (<div className="flex mt-5 px-4">
            <div className="col-12 col-lg-6 mx-auto">

              <h1 className="mb-4">💇‍♀️ ¡Peluquería para la boda! 🎉</h1>
              <p>¿Te gustaría lucir un peinado impecable y elegante para la boda, sin preocupaciones de última hora? 💇‍♀️💫</p>
              <p> En el hotel habrá servicio de peluquería disponible para quien lo desee. Si queréis saber más sobre las tarifas, podéis contactar directamente con <b>Hairlounge by Rossana</b>.</p>

              <div style={{
                textAlign: "center",
                margin: "20px 0",
                fontFamily: "'Roboto', sans-serif",
                backgroundColor: "#f0fafb",
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                maxWidth: "300px",
              }}
                className="my-4 mx-auto"
              >
                <h4 style={{ fontSize: "20px", color: "#0d7377", marginBottom: "10px" }}>
                  Hairlounge by Rossana
                </h4>
                <p style={{ fontSize: "16px", color: "#0d7377", marginBottom: "10px" }}>
                  📞 <a href="tel:953 82 44 40" style={{ color: "#15a5a7", textDecoration: "none" }}>953 82 44 40</a>
                </p>
                <p style={{ fontSize: "16px", color: "#0d7377", marginBottom: "10px" }}>
                  📲 <a href="https://www.instagram.com/hairloungebyrossana" target="_blank" rel="noopener noreferrer" style={{ color: "#15a5a7", textDecoration: "none" }}>@hairloungebyrossana</a>
                </p>
              </div>

              <p>¡Solo necesitamos que os apuntéis aquí abajo para organizarlo todo a la perfección! ✨</p>
              {/* <p>Imagínate: un ratito para ti, buena compañía, risas y, quién sabe, tal vez hasta un debate sobre si el moño alto es el nuevo moño bajo. 💁‍♀️💁‍♂️ No te lo pienses mucho y apúntate a la lista de peluquería. ¡Sin presiones, solo buen rollo! 😊</p> */}

              {/* <p>Te mantendremos informado a través de whatsapp de todos los detalles. ¿Cambios de última hora? ¿Un estilista que cuenta chistes malos mientras te peina? Lo sabrás antes que nadie. 😜📲</p> */}

              {/* <p>Si quieres reservar tu plaza (y evitar el clásico "peinado de última hora hecho con las prisas"), déjanos tus datos aquí abajo:</p> */}

{/* 
              <h2 className="mt-4">Detalles preliminares de la peluquería:</h2>
              <ul className="mt-4">
                <li>
                  <strong>Fecha:</strong> Sábado 21 de junio de 2025
                </li>
                <li>
                  <strong>Lugar:</strong> Salón del hotel
                </li>
              </ul> */}

              <form onSubmit={handleSubmit} className="card shadow p-3" style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                'margin-top': "2rem",
                borderRadius: "10px"
              }}>
                <label>
                  Nombre:
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Tu nombre completo"
                    style={{ width: "100%", padding: "10px", marginTop: "5px" }}
                  />
                </label>

                <label>
                  Teléfono:
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="Tu número de teléfono"
                    style={{ width: "100%", padding: "10px", marginTop: "5px" }}
                  />
                </label>

                <label>
                  Número de personas:
                  <input
                    type="number"
                    name="seats"
                    value={formData.seats}
                    onChange={handleChange}
                    min="1"
                    required
                    style={{ width: "100%", padding: "10px", marginTop: "5px" }}
                  />
                </label>

                <label>
                  Observaciones sobre el peinado:
                  <textarea
                    type="text"
                    name="comments"
                    value={formData.comments}
                    onChange={handleChange}
                    placeholder=""
                    style={{ width: "100%", padding: "10px", marginTop: "5px" }}
                  />
                </label>

                <button
                  type="submit"
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#55aab5",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  ¡Me apunto!
                </button>
              </form>

            </div>
          </div>)}
      </div>
    </section>

  );
};

export default HairSection;
